import DefaultLayout from '@/layouts/DefaultLayout';
import HomeLayout from '@/layouts/HomeLayout';
import Company from '@/views/company/Company';
import HomeIndex from '@/views/home';
import AiHomeIndex from '@/views/ai-home';
import MainIndex from '@/views/main';
import LandingRouter from '@/routes/LandingRouter';
import { TemplateIndex } from '@/views/template';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import History from '../views/history/History';
import Patent from '../views/patent/Patent';
import DataInfuser from '../views/product/DataInfuser';
import QufaStudio from '@/views/product/QufaStudio';
import DataMapMain from '@/views/product/datamap/DataMapMain';

const Routes = () => {
  // Routes
  const routes = [
    {
      element: <DefaultLayout />,
      children: [
        {
          path: '/patents',
          element: <Patent />,
        },
        {
          path: '/histories',
          element: <History />,
        },
        {
          path: '/products/infuser',
          element: <DataInfuser />,
        },
        {
          path: '/products/datamap',
          element: <DataMapMain />,
        },
        {
          path: '/aboutus',
          element: <Company />,
        },
        {
          path: '/products/qufa-studio',
          element: <QufaStudio />,
        },
      ],
    },
  ];

  const homeRoutes = [
    {
      element: <HomeLayout />,
      children: [
        {
          // 설정파일(site-config.json)에 따라 공공데이터/AI 랜딩을 선택 렌더
          path: '/',
          element: <LandingRouter />,
        },
        {
          // 공공데이터 메인 고정 진입점 (직접 링크 공유용)
          path: '/data',
          element: <HomeIndex />,
        },
        {
          // AI 랜딩 고정 진입점 (직접 링크 공유용)
          path: '/ai',
          element: <AiHomeIndex />,
        },
        {
          path: '/template',
          element: <TemplateIndex />,
        },
      ],
    },
  ];

  // 통합 메인 직접 진입점 (레이아웃 없이 풀블리드, 검토/직접 링크용).
  // 루트(/) 노출은 site-config.json 의 defaultLanding='main' 일 때만.
  const previewRoutes = [
    {
      path: '/main',
      element: <MainIndex />,
    },
  ];

  // Combine and conditionally include routes based on authentication status
  const router = createBrowserRouter([...routes, ...homeRoutes, ...previewRoutes]);

  // Provide the router configuration using RouterProvider
  return <RouterProvider router={router} />;
};

export default Routes;
